<template>
  <div class="p-4 border-b border-[--color-gray-line] last-of-type:border-none">
    <router-link :to="link" class="w-full" @click="$emit('linkClick', $event)">
      <div class="flex flex-row w-full text-[--color-body-text] gap-4">
        <div class="w-[120px]">
          <VcImage
            :src="product.imgSrc"
            :alt="product.name"
            size-suffix="lg"
            class="size-full select-none rounded object-contain object-center aspect-video"
            :lazy="lazy"
          />
        </div>
        <div class="w-auto">
          <div class="text-lg font-semibold">
            {{
              // Innovadis custom: Get product name and when it is a variation, prefix with group name
              getProductName(product, true)
            }}
          </div>
          <div v-if="productGroupMaterial" class="text-base">{{ productGroupMaterial }}</div>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script setup lang="ts">
import type { Product } from "@/core/api/graphql/types";
import { getProductRoute } from "@/core/utilities";
import { computed } from "vue";
import { CUSTOM_PROPERTY_GROUP_MATERIAL } from "@/shared/common/constants";
import { getCustomPropertyValue, getProductName } from "@/core/utilities/innovadis";
interface IProps {
  product: Product;
  lazy?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  lazy: true,
});

const link = computed(() => getProductRoute(props.product.id, props.product.slug));

// get group material value from product properties
const productGroupMaterial = computed(() =>
  getCustomPropertyValue(props.product.properties, CUSTOM_PROPERTY_GROUP_MATERIAL),
);
</script>
